<template>
  <div>
    <v-tabs v-model="currentTab" dark class="rounded-lg" dense background-color="primary" active-class="tab-active"
      slider-color="#ffbc00">
      <!-- <v-tabs-slider color="rgb(255, 188, 0)"></v-tabs-slider> -->
      <v-tab class="font-weight-black" v-for="tab in tabs" :key="tab.id" :href="'#' + tab.url">
        {{ tab.name }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="currentTab">
      <v-tab-item v-for="tab in tabs" :key="tab.id" :value="tab.url">
        <component v-bind:is="tab.component"></component>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import CriterioConduta from "./criterios";
import Incidencias from "./incidencias";
import Papeletas from "./papeletas";

export default {
  name: "ManualConvivencia",
  components: {
    CriterioConduta,
    Incidencias,
    Papeletas,
  },
  data() {
    return {
      currentTab: "tab-main",
      tabs: [

        {
          id: 1,
          name: "CRITERIOS DE CONDUCTA",
          url: "criterio-conducta",
          component: "CriterioConduta",
        },

        {
          id: 2,
          name: "INCIDENCIAS",
          url: "incidencias",
          component: "Incidencias",
        },

        {
          id: 3,
          name: "PAPELETAS",
          url: "papeletas",
          component: "Papeletas",
        },

      ],
    };
  },
};
</script>

